import React, {useCallback} from "react";
import './shippingScreen.css';
import {useSearchParams} from "react-router-dom";
import {Breadcrumb, SearchInput} from "shared/ui";
import {useTranslation} from "react-i18next";
import {ShippingSearchParamKey} from "features/shipping/types";

export const ShippingHeader = () => {
  const {t} = useTranslation(["common"]);
  const [searchParams, setSearchParams] = useSearchParams();
  
  const handleSearch = useCallback((value?: string) => {
    setSearchParams(params => {
      if (value?.trim()) params.set(ShippingSearchParamKey.search, value);
      return params;
    })
  }, [setSearchParams]);
  
  return (<div className={"breadcrumb"}>
    <Breadcrumb parentLabel={t("status")} childLabel={t("shipping")} />
    <SearchInput
      placeholder={t("search.place")}
      maxLength={16}
      size={"sm"}
      className={"w-52"}
      value={searchParams.get(ShippingSearchParamKey.search) ?? ""}
      inputMode="numeric"
      onSearch={handleSearch}
    />
  </div>);
};
